module.exports = __webpack_public_path__ + "media/input1.2801ce34.wav";